import types from '@/store/mutationTypes';

const resize = (store) => {
  window.addEventListener('resize', () => {
    store.commit(types.SET_SCREEN_SIZE, window.innerWidth);
    store.commit(types.SET_GAMES_INFO_ACTIVE, store.getters.isDesktop);
  })
};
const initResize = (store) => {
  removeResize();
  store.dispatch('setDeviceLayout');
  store.commit(types.SET_SCREEN_SIZE, window.innerWidth);
  store.commit(types.SET_GAMES_INFO_ACTIVE, store.getters.isDesktop);
  resize(store);
};
const removeResize = () => {
  window.removeEventListener('resize', resize);
  window.removeEventListener('orientationchange', resize);
};

export {
  resize,
  initResize,
  removeResize,
};
